import { SvelteComponent, SvelteComponentDev } from 'svelte/internal';
export { onMount as onMount, onDestroy as onDestroy, beforeUpdate as beforeUpdate, afterUpdate as afterUpdate, setContext as setContext, getContext as getContext, tick as tick, createEventDispatcher as createEventDispatcher, } from 'svelte';
export { flip as flip } from 'svelte/animate';
export { cubicOut as cubicOut, quintOut as quintOut } from 'svelte/easing';
export { blur as blur, fade as fade, fly as fly, slide as slide, scale as scale, draw as draw, crossfade as crossfade, } from 'svelte/transition';
export { readable as readable, writable as writable, derived as derived, get as get, } from 'svelte/store';
/**
 * @param {?SvelteComponent|*} comp
 * @return {boolean}
 */
export function isComponent(comp) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return comp && (comp.__proto__ === SvelteComponent || comp.__proto__ === SvelteComponentDev || comp.__proto__.name === 'ProxyComponent');
}
//# sourceMappingURL=library.js.map